import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Input from 'mrf/view/Input';
import QueryObjectTable from './QueryObjectTable';
import Button from './Button';
import { useSelector } from 'react-redux';
import { FormContext } from './FormCRUD';
import Modal, { useModal } from 'mrf/view/Modal';
import { DialogActions, DialogContent, DialogTitle } from 'mrf/view/Dialog';
import { SearchIcon } from 'styles/components/Icons';
import FormField from './FormField';
import { useFormFullSelector } from 'mrf/redux/ReduxHelper';
import FormQueryObjectTable from './FormQueryObjectTable';
import If from 'mrf/utils/If';

QueryObjectField.propTypes = {
    context: PropTypes.object,

    label: PropTypes.string.isRequired,
    field: PropTypes.string.isRequired, // Field name.
    dialogTitle: PropTypes.string,

    displayAttribute: PropTypes.string, // Object display attribute name.
    displayMap: PropTypes.func, // Object display attribute name.
    resource: PropTypes.string.isRequired, // Resource name to save/retrieve data on redux.

    start: PropTypes.any, // Passthrough to `FormField.cs`.
    required: PropTypes.bool, // Passthrough to `FormField.cs`.
    disabled: PropTypes.bool,
    disableAdd: PropTypes.bool,
}

export default function QueryObjectField({
    context,
    label,
    field,
    dialogTitle=label,
    displayAttribute,
    displayMap,
    required,
    resource,
    start,
    dialog,
    disabled,
    tooltip,
    modalWidth,
    disableAdd = true,
    hideClearButton,
    ...props
}) {
    const formContext = useContext(FormContext);
    if (!context) {
        context = formContext;
    }

    const { data, set } = useFormFullSelector(context, field);

    const tableDialog = useModal();
    if (!dialog) {
        dialog = tableDialog;
    }

    const object = useSelector(state => state.resources?.[resource]?.byId?.[data]);
    const objectValue = (displayMap
        ? object && displayMap(object)
        : object?.[displayAttribute]
    ) ?? '';

    const handleClear = e => {
        e.preventDefault();
        set({ [field]: null });
        dialog.close();
    }

    const selectValue = id => {
        set({ [field]: id });
        dialog.close();
    }

    const QueryObjectTableComponent = disableAdd ? QueryObjectTable : FormQueryObjectTable;

    return (
        <>
            <FormField
                context={context}
                component={Input}
                label={label}
                as='button'
                onChange={() => ({})}
                eventMapper={() => {}}
                required={required}
                onClick={dialog.open}
                start={start}
                end={<button onClick={dialog.open} disabled={disabled}><SearchIcon size={20} /></button>}
                field={field}
                disabled={disabled}
                tooltip={tooltip}
                howToRenderMe={() => object?.[displayAttribute]}
            >
                {objectValue}
            </FormField>

            <Modal {...dialog} width={modalWidth}>
                <DialogTitle>{dialogTitle}</DialogTitle>

                <DialogContent>
                    <QueryObjectTableComponent
                        onClick={selectValue}
                        resource={resource} //For QueryObjectTable
                        tableResource={resource} //For FormQueryObjectTable
                        pageSize={8}
                        {...props}
                    />
                </DialogContent>

                <If condition={!hideClearButton}>
                    <DialogActions>
                        <Button color='secondary' onClick={handleClear}>Clear</Button>
                    </DialogActions>
                </If>
            </Modal>
        </>
    );
}
